import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { InfoIcon, Loader2 } from 'lucide-react';

interface DeleteGroupDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  groupName: string;
  contactCount: number;
  onConfirm: () => void | Promise<void>;
  isDeleting?: boolean;
}

export function DeleteGroupDialog({
  open,
  onOpenChange,
  groupName,
  contactCount,
  onConfirm,
  isDeleting = false,
}: DeleteGroupDialogProps) {
  const handleConfirm = async () => {
    // Call the confirm handler - parent will close dialog after completion
    await onConfirm();
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Group: {groupName}?</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-4">
              <p>
                This will remove the group label only.{' '}
                <strong>The {contactCount} contact{contactCount !== 1 ? 's' : ''} in this group will NOT be deleted.</strong>
              </p>

              <Alert>
                <InfoIcon className="h-4 w-4" />
                <AlertDescription>
                  <strong>To delete contacts:</strong> Go to Contacts, filter by this group,
                  select all contacts, then click Delete.
                </AlertDescription>
              </Alert>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDeleting}>Cancel</AlertDialogCancel>
          <Button
            onClick={handleConfirm}
            disabled={isDeleting}
            variant="destructive"
          >
            {isDeleting ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Deleting...
              </>
            ) : (
              'Delete Group'
            )}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
